import { t } from '@lingui/macro';

export const meritLabel = (i18n, position, stepCount, isEarned) => (isEarned ?
  i18n._(t`Merit ${position} of ${stepCount} earned`) :
  i18n._(t`Merit ${position} of ${stepCount} not earned yet`)
)
  .replace('{position}', position)
  .replace('{stepCount}', stepCount);

export const meritEarnedAnnouncement = (i18n, stepsCompleted, stepCount) =>
  i18n._(t`Merit earned. You now have ${stepsCompleted} of ${stepCount} Merits.`)
    .replace('{stepsCompleted}', stepsCompleted)
    .replace('{stepCount}', stepCount);
